// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProfileView.css */
/* Uses utilities: .section-bg, .text-center */


.profile-grid .profile__main {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin-bottom: 0;
  overflow-wrap: anywhere;
  align-items: flex-start;
}

.profile-grid .profile__sidebar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  border-radius: var(--border-radius-base);
  background: var(--color-background, #F8F9FB);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: clip;
}

.profile-grid .profile__section {
  padding: var(--spacing-lg);
  border-radius: var(--border-radius-base);
  background: var(--white, #FFF);
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: clip;
}

.profile-grid .profile__section--empty {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: clip;
}


/* SAM Not sure this is needed, and potentially should be moved somewhere else */
.profile-grid .phone-type {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-base);
  color: var(--color-text-secondary);
}

@container profile-pane (max-width: 1000px) {
  #main-content.profile-grid {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin-inline: auto !important;
    padding-inline: var(--spacing-sm, 0.75rem) !important;
  }
}

`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/ProfileView.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB,8CAA8C;;;AAG9C;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,wCAAwC;EACxC,4CAA4C;EAC5C,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;;AAGA,gFAAgF;AAChF;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,8BAA8B;IAC9B,qDAAqD;EACvD;AACF","sourcesContent":["/* ProfileView.css */\n/* Uses utilities: .section-bg, .text-center */\n\n\n.profile-grid .profile__main {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  margin-bottom: 0;\n  overflow-wrap: anywhere;\n  align-items: flex-start;\n}\n\n.profile-grid .profile__sidebar {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  text-align: left;\n  border-radius: var(--border-radius-base);\n  background: var(--color-background, #F8F9FB);\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  overflow-x: clip;\n}\n\n.profile-grid .profile__section {\n  padding: var(--spacing-lg);\n  border-radius: var(--border-radius-base);\n  background: var(--white, #FFF);\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: clip;\n}\n\n.profile-grid .profile__section--empty {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: clip;\n}\n\n\n/* SAM Not sure this is needed, and potentially should be moved somewhere else */\n.profile-grid .phone-type {\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-base);\n  color: var(--color-text-secondary);\n}\n\n@container profile-pane (max-width: 1000px) {\n  #main-content.profile-grid {\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    margin-inline: auto !important;\n    padding-inline: var(--spacing-sm, 0.75rem) !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
